import React from "react";
import { Navigate } from "react-router-dom";

import { DemoProvider } from "@/features/demo/components/DemoProvider";
import ExpoPageV3 from "@/features/restaurant/pages/ExpoPage.V3";
import { ProtectedRouteV2 } from "@/components/ProtectedRouteV2";
import { useSmartRouteResolution } from "./smart-routes/useSmartRouteResolution";

const LEGACY_REDIRECTS: Record<string, string> = {};

export const SmartExpoRoute: React.FC = () => {
  const resolution = useSmartRouteResolution({
    routeKey: "expo",
    legacyRedirects: LEGACY_REDIRECTS,
  });

  if (resolution.redirectPath) {
    return <Navigate to={resolution.redirectPath} replace />;
  }

  if (resolution.shouldRenderDemo) {
    return (
      <DemoProvider>
        <ExpoPageV3 />
      </DemoProvider>
    );
  }

  return (
    <ProtectedRouteV2 legacyPage="expo">
      <ExpoPageV3 />
    </ProtectedRouteV2>
  );
};

export default SmartExpoRoute;
